// Vite raw imports — bundle the markdown content at build time.
import webTosContent from './web-tos-v1.md?raw';
import privacyPolicyContent from './privacy-policy-v1.md?raw';

export const AGREEMENT_VERSIONS = {
  web_tos: '1.0',
  privacy_policy: '1.0',
} as const;

export const AGREEMENT_EFFECTIVE_DATE = '2026-04-26';

export const AGREEMENT_DOCS = {
  web_tos: {
    type: 'web_tos' as const,
    version: AGREEMENT_VERSIONS.web_tos,
    title: 'Terms of Service',
    shortTitle: 'Terms of Service',
    content: webTosContent,
  },
  privacy_policy: {
    type: 'privacy_policy' as const,
    version: AGREEMENT_VERSIONS.privacy_policy,
    title: 'Privacy Policy',
    shortTitle: 'Privacy Policy',
    content: privacyPolicyContent,
  },
} as const;

export type AgreementType = keyof typeof AGREEMENT_DOCS;

const ACCEPTED_KEY = 'ealoom.agreementsAccepted.v1';

interface StoredAcceptance {
  web_tos?: { version: string; acceptedAt: string };
  privacy_policy?: { version: string; acceptedAt: string };
}

export function getStoredAcceptance(): StoredAcceptance {
  try {
    const raw = localStorage.getItem(ACCEPTED_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function storeAcceptance(types: AgreementType[]) {
  const existing = getStoredAcceptance();
  const now = new Date().toISOString();
  for (const t of types) {
    existing[t] = { version: AGREEMENT_VERSIONS[t], acceptedAt: now };
  }
  localStorage.setItem(ACCEPTED_KEY, JSON.stringify(existing));
}

export function clearStoredAcceptance() {
  localStorage.removeItem(ACCEPTED_KEY);
}

export function needsAcceptance(types: AgreementType[]): boolean {
  const stored = getStoredAcceptance();
  return types.some((t) => stored[t]?.version !== AGREEMENT_VERSIONS[t]);
}
